export default __webpack_public_path__ + "static/media/interior-2.feac99c9.jpg";